/*
**注意：此文件不能独立加载，基于axios和element-ui使用
**作用：封装axios的全局设置
*/

import Vue from 'vue'
import axios from 'axios'
import router from '../router';

// 是否正在刷新的标记
var isRefreshing = false;
// 重试队列，每一项将是一个待执行的函数形式
var requests = [];
//站点ID
const $site = 1;
//WebApi接口地址
export let baseApi = "https://ms.fuxinsz.com";
// export let baseApi = "http://localhost:7070";  //开 发
// export const baseApi = "http://192.168.0.235:10060";  //开 发
export const uploadApi = "https://ms.fuxinsz.com";
// export const uploadApi = "http://192.168.0.235:10060";  //开 发

export const downApi = "https://ms.fuxinsz.com";
//虚拟电厂
export const dcApi = "http://localhost:8080/api";

//测算
export const csApi = "https://api.fuxinsz.com/";
// export const csApi = "http://localhost:8100";//开 发

// export const baseApi = "http://5wqitt.natappfree.cc";
// export const uploadApi = "http://5wqitt.natappfree.cc";
// export const downApi = "http://5wqitt.natappfree.cc";
// const baseApi = "http://5gpeyp.natappfree.cc";
//const baseApi = "http://106.13.21.74";
if (process.env.NODE_ENV == 'production') {
	baseApi = "https://ms.fuxinsz.com";
}

//axios实例
const instance = axios.create({
	baseURL: baseApi,
	timeout: 60000,//设置请求超时时间
	headers: {
		"content-type": "application/json"
	}
});



//存储Token到本地
export function saveToken(accessToken, refreshToken) {
	window.localStorage.setItem('fx_client_access_token', accessToken);
	window.localStorage.setItem('fx_client_refresh_token', refreshToken);
}

export function saveLoginData(obj) {
	window.localStorage.setItem('fx_login_companyType', obj.company.companyType);
	window.localStorage.setItem('fx_login_companyId', obj.company.id);
	window.localStorage.setItem('fx_login_company', obj.company.companyFullName);
	window.localStorage.setItem('fx_login_username', obj.user.username);
}

export function saveCompanyData(obj) {
	window.localStorage.setItem('fx_company_data', JSON.stringify(obj));
}

export function getCompanyData() {
	return JSON.parse(window.localStorage.getItem('fx_company_data'));
}

export function saveModelData(obj) {
	window.localStorage.setItem('fx_model_data', JSON.stringify(obj));
}

export function getModelData() {
	return JSON.parse(window.localStorage.getItem('fx_model_data'));
}

//刷新Token请求方法
export function refreshToken(axiosObj, error) {
	let refreshToken = window.localStorage.getItem('fx_client_refresh_token');
	if (!refreshToken) {
		//window.location.href='/account/login';
	}
	//console.log('开始刷新Token...');
	const config = error.response.config;
	if (!isRefreshing) {
		isRefreshing = true;
		let isRefreshed = false;
		return instance.post('auth/retoken', { 'refreshToken': refreshToken }).then(res => {
			console.log('刷新成功');
			//设置请求头
			config.headers.Authorization = '' + res.data.accessToken;
			//存储Token
			saveToken(res.data.accessToken, res.data.refreshToken);
			//已经刷新了token，将所有队列中的请求进行重试
			requests.forEach(cb => cb(res.data.accessToken))
			//重试完了清空这个队列
			requests = [];
			isRefreshed = true;
			return axiosObj(config);
		}).catch(err => {
			//console.log('出错了：' + isRefreshing);
			//无法刷新Token时重新登录
			if (!isRefreshed) {
				Vue.prototype.$alert('认证失效，请重新登录!', '登录过期', {
					confirmButtonText: '确认',
					callback: action => {
						localStorage.setItem('fx_client_access_token', '');
						localStorage.setItem('fx_client_refresh_token', '');
						window.location.href = '/login';
					}
				})
			}
			return Promise.reject(err);
		}).finally(() => {
			isRefreshing = false
		})
	} else {
		//正在刷新token，返回一个未执行resolve的promise
		return new Promise((resolve) => {
			console.log('加入队列...');
			//将resolve放进队列，用一个函数形式来保存，等token刷新后直接执行
			requests.push((token) => {
				config.headers.Authorization = '' + token;
				resolve(axiosObj(config));
			})
		})
	}

}
//添加请求拦截器
instance.interceptors.request.use(
	config => {
		//判断是否是请求虚拟电厂
		let token = null;
		if (config.url.slice(0, 3) === "/v2" || config.url.slice(0, 9) === "/getToken") {
			instance.defaults.baseURL = dcApi
			config.baseURL = dcApi
			//获取token
			let token2 = window.localStorage.getItem('fx_virtual_power_plant_token') || null;
			let token1 = { "appId": "5T6U3BU78COS897", "sign": "0fa872910e442a719e4a02d9140c7135e3eeebaf3efe2eb8f3e6ab8945722d8e", "token": token2 };
			token = JSON.stringify(token1)
			// if (config.url.slice(0, 9) === "/getToken") {

			// 	token = null
			// }
		} else if (config.url.slice(0, 12) === "/calculation") {
			instance.defaults.baseURL = csApi
			config.baseURL = csApi
		}

		else {
			instance.defaults.baseURL = baseApi
			config.baseURL = baseApi
			//获取token
			token = window.localStorage.getItem('fx_client_access_token');
		}
		if (token) {
			//判断是否存在token，如果存在的话，则每个http header都加上token
			config.headers.Authorization = '' + token;
		}
		return config;
	},
	error => {
		return Promise.reject(error);
	}
);
//添加响应拦截器
instance.interceptors.response.use(
	response => {
		if (response.status) {
			return Promise.resolve(response);
		} else {
			return Promise.reject(response);
		}
	},
	error => {
		if (error.response && error.response.status === 401 && error.response.headers["token-expired"]) {
			if (parent.Vue) {
				return window.parent.refreshToken(instance, error);
			} else {
				return refreshToken(instance, error);
			}
		}
		return Promise.reject(error);
	}
);

//封装axios方法
export function AxiosAjax(params) {
	/* 参数示例
	 * AxiosAjax({method:'get',url:'auth/login',data:...});
	 * @param {method,url,data,loading,beforeSend,progress,success,successMsg,error,complete,completeMsg}
	 */
	let _this = Vue;//当前VUE实例
	//加载Loading
	let loadingInstance = params.loading ? _this.prototype.$loading({ body: true, lock: true }) : null;
	//发送请求前调用
	if (params.beforeSend) params.beforeSend();
	//定义参数配置
	let method = params.method,
		url = params.url,
		callback = res => {
			if (params.loading) loadingInstance.close();

			if (!res.status) {
				_this.prototype.$message({
					message: "请求失败，请重试...",
					type: 'error'
				});
			}
			//成功
			else if (res.status === 200 || res.status === 204) {
				//未登录
				if (res.data.code == "100001") {
					localStorage.setItem('fx_client_access_token', '');
					localStorage.setItem('fx_client_refresh_token', '');
					localStorage.setItem("fx_menu_selected_id", '')
					window.location.href = '/login'
				}

				if (method == 'down') {
					if (params.success) params.success(res);
				} else {

					if (params.successMsg) {

						_this.prototype.$message({
							message: params.successMsg,
							type: "success"
						});
					}

					if (params.success) params.success(res);
					if (res.data.code == 200) {

					} else if (res.data.BatteryClusters) {

					} else if (res.data.code != "000000") {

						_this.prototype.$message({
							message: res.data.msg,
							type: "error"
						});

						// //未登录
						// if (res.data.code=="100001") {
						// 	localStorage.setItem("fx_menu_selected_id", '')
						// 	window.location.href = '/login'
						// }
					} else {
						if (params.successMsg) {
							_this.prototype.$message({
								message: params.successMsg,
								type: "success",
							});
						}

					}
				}
			} else { //其它
				_this.prototype.$message({
					message: res.data.message,
					type: 'error'
				});
			}
			if (params.complete) params.complete();
		},
		error = err => {
			if (params.loading) loadingInstance.close();
			console.log(err)
			//网络错误
			if (!err.response) {
				_this.prototype.$message({ type: 'error', message: "请求失败，请检查网络..." });

			}
			//401:没有权限
			else if (err.response.status === 401 && err.response.data.code === 10001) {
				_this.prototype.$message({
					message: "请求失败，没有操作权限",
					type: 'warning'
				});
			}
			//401:
			else if (err.response.status === 401 && !err.response.data) {

			}
			//422:数据验证未通过
			else if (err.response.status === 422) {
				_this.prototype.$message({
					message: err.response.data.message[0][0],
					type: 'warning'
				});
			}
			else if (err.response.status === 403) {
				//403暂不处理
			}
			else if (err.response.status === 404) {
				//404暂不处理
				//console.log(err.response);
			}
			//其它错误
			else {
				_this.prototype.$message({
					message: typeof (err.response.data) != "undefined" ? err.response.data.message : err,
					type: 'error'
				});
			}
			//执行完成之后的回调函数
			if (params.error) params.error(err);
			if (params.complete) params.complete(err);
		};
	//封装Promise
	return new Promise(resolve => {
		if (!method || method === "get") {
			if (params.data) {
				instance.get(url, params.data).then(res => {
					resolve(callback(res));
				}).catch(error => {
					console.log(error)
				});
			} else {
				instance.get(url).then(res => {
					resolve(callback(res));
				}).catch(error => {
					console.log(error)
				});
			}

		} else {
			if (method === "file") {
				instance.headers = {
					"content-type": "multipart/form-data"
				};
				if (params.progress) {
					instance.post(url, params.data, { onUploadProgress: params.progress }).then(res => {
						resolve(callback(res));
					}).catch(error);
				} else {
					instance.post(url, params.data).then(res => {
						resolve(callback(res));
					}).catch(error);
				}
			} else if (method === "down") {
				instance.get(url, {
					responseType: 'blob',
				}).then(res => {
					resolve(callback(res));
				}).catch(error);
			} else if (method === "post") {
				instance.post(url, params.data).then(res => {

					resolve(callback(res));
				}).catch(error);
			} else if (method === "delete") {
				instance.delete(url, params.data).then(res => {
					resolve(callback(res));
				}).catch(error);
			} else if (method === "put") {
				instance.put(url, params.data).then(res => {
					resolve(callback(res));
				}).catch(error);
			} else if (method === "patch") {
				instance.patch(url, params.data).then(res => {
					resolve(callback(res));
				}).catch(error);
			}
		}
	});
};


/**
 * 页面发生改变时执行
 */
export function pageResize() {
	var w = window.innerWidth;
	if (w > 500) {
		if (typeof (ve) != "undefined" && ve.labelPosition) ve.labelPosition = "right";
	} else {
		if (typeof (ve) != "undefined" && ve.labelPosition) ve.labelPosition = "top";
	}
	if (w > 800) {
		//if (typeof (vm) != "undefined" && typeof (vm.isCollapse) != "undefined") vm.isCollapse = false;
	} else {
		//if (typeof (vm) != "undefined" && typeof (vm.isCollapse) != "undefined") vm.isCollapse = true;
	}
	if (typeof (vm) != "undefined" && vm.mainPageInit) vm.mainPageInit();
	if (typeof (vm) != "undefined" && vm.echartList) {
		vm.echartList.forEach(function (chart) {
			chart.resize();
		});
	}
}
window.onload = function () {
	pageResize();
	window.onresize = function () {
		pageResize(); //页面发生改变时
	}
}

/**
 * [通过参数名获取url中的参数值]
 * 示例URL:http://htmlJsTest/getrequest.html?uid=admin&rid=1&fid=2&name=小明
 * @param  {[string]} queryName [参数名]
 * @return {[string]}           [参数值]
 */
export function GetQueryValue(queryName) {
	var query = decodeURI(window.location.search.substring(1));
	var vars = query.split("&");
	for (var i = 0; i < vars.length; i++) {
		var pair = vars[i].split("=");
		if (pair[0].toLowerCase() == queryName.toLowerCase()) { return pair[1]; }
	}
	return null;
}

//时间格式化
Date.prototype.pattern = function (fmt) {

	var o = {
		"M+": this.getMonth() + 1, //月份         
		"d+": this.getDate(), //日         
		"h+": this.getHours() % 12 == 0 ? 12 : this.getHours() % 12, //小时         
		"H+": this.getHours(), //小时         
		"m+": this.getMinutes(), //分         
		"s+": this.getSeconds(), //秒         
		"q+": Math.floor((this.getMonth() + 3) / 3), //季度         
		"S": this.getMilliseconds() //毫秒         
	};
	var week = {
		"0": "/u65e5",
		"1": "/u4e00",
		"2": "/u4e8c",
		"3": "/u4e09",
		"4": "/u56db",
		"5": "/u4e94",
		"6": "/u516d"
	};
	if (/(y+)/.test(fmt)) {
		fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
	}
	if (/(E+)/.test(fmt)) {
		fmt = fmt.replace(RegExp.$1, ((RegExp.$1.length > 1) ? (RegExp.$1.length > 2 ? "/u661f/u671f" : "/u5468") : "") + week[this.getDay() + ""]);
	}
	for (var k in o) {
		if (new RegExp("(" + k + ")").test(fmt)) {
			fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
		}
	}
	return fmt;
}

// //时间加减 https://www.cnblogs.com/jzzszyj/p/6528414.html
// function dateChange(num = 1,date = false) {
// 　　if (!date) {
// 　　　　date = new Date();//没有传入值时,默认是当前日期
// 　　　　date = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
// 　　}
// 　　date += " 00:00:00";//设置为当天凌晨12点
// 　　date = Date.parse(new Date(date))/1000;//转换为时间戳
// 　　date += (86400) * num;//修改后的时间戳
// 　　var newDate = new Date(parseInt(date) * 1000);//转换为时间
// 　　return newDate.getFullYear() + '-' + (newDate.getMonth() + 1) + '-' + newDate.getDate();
// }

//https://www.cnblogs.com/1906859953lucas/p/9067434.html
// 日期，在原有日期基础上，增加days天数，默认增加1天 
export function addDate(date, days) {
	if (days == undefined || days == '') { days = 0; }
	var date = new Date(date);
	date.setDate(date.getDate() + days);
	var month = date.getMonth() + 1;
	var day = date.getDate();
	return date.getFullYear() + '-' + getFormatDate(month) + '-' + getFormatDate(day);
}

//月份，在原有的日期基础上，增加 months 月份，默认增加1月
export function addMonth(date, months) {
	if (months == undefined || months == '') { months = 0; }

	var date = new Date(date);
	date.setMonth(date.getMonth() + months);
	var month = date.getMonth() + 1;
	var day = date.getDate();
	//return date.getFullYear()+'-'+getFormatDate(month)+'-'+getFormatDate(day);
	return date.getFullYear() + '-' + getFormatDate(month);
}

// 日期月份/天的显示，如果是1位数，则在前面加上'0'
export function getFormatDate(arg) {
	if (arg == undefined || arg == '') {
		return '';
	}
	var re = arg + '';
	if (re.length < 2) {
		re = '0' + re;
	}
	return re;
}


// WEBPACK FOOTER //
// ./src/js/axios.config.js